import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MotifPaginationModel } from './motif-pagination.model';
import { FwcPagination } from '../../../../fwc-lib.js';

@Component({
    selector: 'mt-pagination',
    templateUrl: './motif-pagination.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MotifPaginationComponent implements OnInit, OnChanges{
  @Input() model: any;
  @Output() updateActivePage: EventEmitter<MotifPaginationModel>;
  fwcPagination: any;

  constructor() {
    this.updateActivePage = new EventEmitter();
  }

  ngOnInit(): void {
    if(typeof this.model !== 'string'){
      this.model = JSON.stringify(this.model);
    }
    this.fwcPagination = new FwcPagination();
    this.fwcPagination.build();
  }

updateActivePagination(event): void {
  this.updateActivePage.emit(event.detail);
}

ngOnChanges(changes: SimpleChanges): void {
  if (changes.model){
    this.model = JSON.stringify(this.model);
  }
}

}

